import { Metric } from './analytics-api/schema.model';
import { IMetricFilter } from '../interfaces/query-filter.interface';
import { hasValue } from '../utils/filter.util';

export class MetricFilter {
  public dataset?: string;
  public type: string;
  public key: string;
  public value: number;
  public metric: Metric = undefined;

  constructor(
    object: IMetricFilter,
  ) {
    this.type = object.type;
    this.value = object.value;

    if (!!object.metric) {
      this.metric = new Metric(object.metric.name, object.metric.meta);
    }

    if (object.dataset) {
      this.dataset = object.dataset;
    }

    this.key = object.key;
  }

  public asJson() {
    return {
      type: this.type,
      value: this.value,
      metric: this.metric && { name: this.metric.name },
      key: this.key,
    };
  }

  analyticsPayload() {
    if (this.type === 'na' || this.type === 'not_na') {
      return {
        type: this.type === 'na' ? 'any' : 'not_any',
        values: '',
        key: this.analyticsApiKey,
      };
    }
    if (!hasValue(this.value)) {
      return null;
    }
    return {
      type: this.type,
      values: this.value,
      key: this.analyticsApiKey,
    };
  }

  private get analyticsApiKey(): string {
    switch (this.type) {
      case 'na':
      case 'not_na':
        return this.metric?.name || this.key;
      default:
        return this.key;
    }
  }

}
